import $ from 'jquery';
import AjaxRequest from "../modules/ajax-request";
import LazyLoad from "vanilla-lazyload"

class Ranking {
    constructor(element) {
        this.div = element;
        this.url = "";

        this.getData();
        this.clearData();
        this.init();
    }
    getData() {
        this.url = $(this.div).data("url");
    }
    clearData() {
        $(this.div).removeAttr("data-url");
    }
    init() {
        var _div = this.div;
        var ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_div).replaceWith(response.message);
                var myLazyLoad = new LazyLoad();
            }
        });
        ajaxRequest.makeCall(this.url);
    }
}

export default Ranking
